import React, {Component, useState, useEffect, useCallback} from 'react';
import {useLocation, useHistory} from 'react-router';
import {withRouter} from 'react-router-dom';
import queryString from 'query-string';

function withUrlState(initialState = {}) {
  return C => withRouter(class WithUrlState extends Component {
    static displayName = `withUrlState(${C.displayName || C.name})`;

    // Callbacks to invoke when the URL changes.
    listeners = [];

    componentDidUpdate(prevProps) {
      const {location: {search}} = this.props;

      if (prevProps.location.search !== search) {
        this.listeners.forEach(f => f(this.getUrlState()));
      }
    }

    handleSetUrlState = (nextUrlState, method = 'replace') => {
      const {history, location} = this.props;
      const currentUrlState = queryString.parse(location.search);
      const nextQueryString = {
        ...currentUrlState,
        ...(typeof nextUrlState === 'function' ? nextUrlState(currentUrlState) : nextUrlState)
      };

      history[method](`?${queryString.stringify(nextQueryString)}`);
    };

    getUrlState = () => {
      const {location} = this.props;

      return {
        ...initialState,
        ...queryString.parse(location.search)
      };
    }

    handleUrlStateChange = f => {
      this.listeners.push(f);
    }

    render() {
      return (
        <C
          {...this.props}
          urlState={this.getUrlState()}
          setUrlState={this.handleSetUrlState}
          onUrlStateChange={this.handleUrlStateChange}
        />
      );
    }
  });
}

export default withUrlState;

export function useUrlState(initialState = {}) {
  const {search} = useLocation();
  const history = useHistory();
  const [state, setState] = useState(initialState);

  useEffect(() => {
    setState(prevState => ({
      ...prevState,
      ...queryString.parse(search),
    }));
  }, [search]);

  const handleSetUrlState = useCallback((nextUrlState, method = 'replace') => {
    const currentUrlState = queryString.parse(search);
    const nextQueryString = {
      ...currentUrlState,
      ...(typeof nextUrlState === 'function' ? nextUrlState(currentUrlState) : nextUrlState)
    };

    history[method](`?${queryString.stringify(nextQueryString)}`);
  }, [search, history]);

  return [state, handleSetUrlState];
}